import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";

const ReachOutAmount = () => {
  const [studentAmount, setStudentAmount] = useState("");
  const [clientAmount, setClientAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch the existing amounts using GET request
  useEffect(() => {
    const fetchAmounts = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");

      // If there's no token, alert the user
      if (!token) {
        alert("No token found. Please log in.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "https://admindashboard.clns.in/api/dashboard/reach_amount/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Pass the token in the header
            },
          }
        );
        const data = await response.json();

        console.log(data?.reachout_amount.client_amount,"dataaa")
        if (response.ok) {
          setStudentAmount(data?.reachout_amount.student_amount || ""); // Set the fetched student amount
          setClientAmount(data?.reachout_amount.client_amount || ""); // Set the fetched client amount
        } else {
          setError("Error fetching data");
        }
      } catch (err) {
        console.error("Error occurred while fetching data:", err);
        setError("An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchAmounts();
  }, []);

  // Handle input change for Student Reach Out Amount
  const handleStudentAmountChange = (event) => {
    setStudentAmount(event.target.value);
  };

  // Handle input change for Client Reach Out Amount
  const handleClientAmountChange = (event) => {
    setClientAmount(event.target.value);
  };

  // Handle Reset Button click
  const handleReset = () => {
    setStudentAmount("");
    setClientAmount("");
  };

  // Handle Save Button click (API call)
  const handleSave = async () => {
    const payload = {
      student_amount: studentAmount,
      client_amount: clientAmount,
    };

    const token = localStorage.getItem("token");

    // If there's no token, alert the user
    if (!token) {
      alert("No token found in local storage. Please log in.");
      return;
    }

    try {
      const response = await fetch(
        "https://admindashboard.clns.in/api/dashboard/reach_amount/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Pass the token in the header
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (response.ok) {
        alert("Data saved successfully!");
        console.log(data);
      } else {
        alert("Error saving data.");
      }
    } catch (error) {
      console.error("Error occurred while saving data:", error);
      alert("An error occurred.");
    }
  };

  console.log(clientAmount,"clientAmount")

  return (
    <>
      <div
        style={{
          display: "grid",
          gap: "20px",
          paddingLeft: "10%",
          paddingTop: "5%",
        }}
      >
        <div
          style={{
            border: "1px hidden black",
            width: "100%",
            height: "60vh",
            boxShadow: "0.5px 0.5px 1px 1px grey",
            borderRadius: "5px",
            display: "grid",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateRows: "22% 88%",
              gap: "20px",
            }}
          >
            <div
              style={{
                border: "1px hidden black",
                borderTopRightRadius: "5px",
                borderTopLeftRadius: "5px",
                backgroundColor: "blue",
                color: "white",
                paddingLeft: "40%",
                paddingTop: "5px",
              }}
            >
              Student Reach Out Amount
            </div>
            <div style={{ paddingLeft: "20px", paddingTop: "5px" }}>
              <label>Reach out amount</label>
              <br />
              <input
                type="number"
                style={{ width: "50%" }}
                value={studentAmount}
                onChange={handleStudentAmountChange}
              />
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateRows: "15% 85%",
              gap: "30px",
            }}
          >
            <div
              style={{
                border: "1px hidden black",
                backgroundColor: "blue",
                color: "white",
                paddingLeft: "40%",
                paddingTop: "5px",
              }}
            >
              Client Reach Out Amount
            </div>
            <div style={{ paddingLeft: "20px", paddingTop: "5px" }}>
              <label>Reach out amount</label>
              <br />
              <input
                type="number"
                style={{ width: "50%" }}
                value={clientAmount}
                onChange={handleClientAmountChange}
              />
              <br />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "auto",
                  padding: "20px",
                  marginRight: "20px",
                }}
              >
                <Button variant="outline-dark" style={{ width: "20%" }} onClick={handleReset}>
                  Reset
                </Button>
                <Button variant="primary" style={{ width: "20%" }} onClick={handleSave}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loading and error states */}
      {loading && <div>Loading...</div>}
      {error && <div>{error}</div>}
    </>
  );
};

export default ReachOutAmount;
